import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Panel from "./pages/Panel";
import NotFound from "./pages/NotFound";
//css
import "./App.css";

const App = () => {
  const defaultLocation = {
    state: false,
    lat: 32.938058,
    lng: 21.714991,
    acc: 0,
  };

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/panel" element={<Panel myLocation={defaultLocation} />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
